<template>
  <div class="container form-step">
    <Loader v-if="loading" />
    <div class="p-grid p-jc-center">
      <div class="p-col-8">
        <div class="card">
          <Steps :model="items" :readonly="true" />
        </div>
        <Card v-if="loading_caricamento">
          <template v-slot:content>
            <div class="w-full stat-card card-primary">
              <div class="stat-card-content">
                <div class="stat-title">
                  <span v-if="route.params.id">Importazione dati caricamento #{{ route.params.id }}</span>
                  <span v-else>Caricamento dati</span>
                  <span class="animated-dots">
                    <span>.</span><span>.</span><span>.</span>
                  </span>
                </div>
              </div>
            </div>
          </template> 
        </Card>

        <router-view :key="reloadKey" v-slot="{Component}" :formData="formObject" @activeLoader="activeLoader" @activeLoaderCaricamento="activeLoaderCaricamento" @prev-page="prevPage($event)" @next-page="nextPage($event)" @complete="complete">
          <keep-alive>
            <component :is="Component" v-show="!loading_caricamento"/>
          </keep-alive>
        </router-view>
      </div>       
    </div>
  </div>
</template>

<script>

import { onBeforeMount, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Steps from 'primevue/steps';
import Loader from "@/components/Loader.vue"

export default {
    components: {
        Steps,
        Loader
    },
    setup() { 
      const route = useRoute()
      const items = ref([
        {
          label: 'Info Contratto',
          to: "/multisito/step-info"
        },
        {
          label: 'Rappresentante/Contatto',
          to: "/multisito/step-rappresentante"
        },
        {
          label: 'Carica Dati',
          to: "/multisito/step-upload"
        },
        {
          label: 'Carica Documenti',
          to: "/multisito/step-documenti"
        },
      ]);
      const getPath = (index, id = null) => {
        const basePath = items.value[index].to;
        const finalPath = id ? `${basePath}/${id}` : basePath;
        return finalPath;
      }
      const getReloadQuery = () => {
        return route.query.reload ? {reload: route.query.reload} : {}
      }
      
      onMounted(() => {
        const primoStepPath = getPath(0, route.params.id);
        const stepAvanzatiPaths = items.value.slice(1).map(item => item.to);
        const isSuUnoStepAvanzato = stepAvanzatiPaths.some(path => route.path.startsWith(path));
        const isFormVuoto = Object.keys(formObject.value).length === 0;

        if (isFormVuoto && isSuUnoStepAvanzato) {
          console.warn("Hard refresh intercettato su uno step avanzato del form. Ripristino la sessione dallo step iniziale.");
          router.replace(primoStepPath);
          return;
        }

        if (route.path !== primoStepPath && Object.keys(formObject.value).length > 0) {
          router.replace(primoStepPath);
          return;
        }

        router.push(primoStepPath);

      })

      const loading = ref(false)
      const loading_caricamento = ref(false)
      const loadingCaricamentoLocks = ref(new Set())
      const reloadKey = ref(0);
      const formObject = ref({});
      const router = useRouter();
      

      const nextPage = (event) => {
        loading.value = true
        for (let field in event.formData) {               
          formObject.value[field] = event.formData[field];
        }
        router.push({path: getPath(event.pageIndex + 1, route.params.id), query: getReloadQuery()})
        setTimeout(() => {
          loading.value = false
        }, 2000)
      };
      const prevPage = (event) => {
        loading.value = true
        if (event?.formData) {
          for (let field in event.formData) {
            formObject.value[field] = event.formData[field];
          }
        }
        router.push({path: getPath(event.pageIndex - 1, route.params.id), query: getReloadQuery()});
        setTimeout(() => {
          loading.value = false
        }, 2000)
      };
      let completing = false
      const complete = async () => {
        if (completing) return
        completing = true
        try {
          const failure = await router.push(getPath(0))
          if (failure && route.path !== getPath(0)) return
          formObject.value = {}
          loadingCaricamentoLocks.value = new Set()
          loading_caricamento.value = false
          loading.value = false
          reloadKey.value++
        } finally {
          completing = false
        }
      };

      const activeLoader = (bool) => {
        loading.value = bool
      }

      const activeLoaderCaricamento = (payload) => {
        if (payload && typeof payload === 'object') {
          const source = payload.source || 'default'
          const locks = new Set(loadingCaricamentoLocks.value)

          if (payload.active) {
            locks.add(source)
          } else {
            locks.delete(source)
          }

          loadingCaricamentoLocks.value = locks
          loading_caricamento.value = locks.size > 0
          return
        }

        if (payload === false && loadingCaricamentoLocks.value.size > 0) return
        loading_caricamento.value = payload
      }

      return { items, formObject, nextPage, prevPage, complete, reloadKey, activeLoader, activeLoaderCaricamento, loading, loading_caricamento, route }
    }
}
</script>
<style>
  .card-primary {
    background: linear-gradient(135deg, #215159 0%, #1a7f89 100%);
  }
  .box-option{
    margin: 10px;
    border-radius: 20px;
    /* border-bottom: 1px solid #1a7f89; */
    border: 1px solid #1a7f89;
  }

</style>
<style scoped>
 b {
  display: block;
 }

.form-step .p-card-body {
     padding: 2rem;
 }
 .form-step .p-card {
     box-shadow: none !important;
 }
 
  .form-step .p-field input ,  .form-step .p-dropdown{
     background-color: rgba(219, 219, 219, 0.45);
     border: 1px solid rgba(255, 255, 255, 0);
     height: 44px;
 }
 .form-step .p-field {
     text-align: left;
 }

 .form-step .p-error {
     font-size: 13px;
 }

   .animated-dots {
    display: inline-flex;
    margin-left: 4px;
  }
  
  .animated-dots span {
    display: inline-block;
    animation: dot-jump 1.4s infinite ease-in-out;
    /* Assicuriamoci che i punti ereditino lo stile del titolo */
    color: white; 
  }
  
  /* Ritardi per l'effetto onda */
  .animated-dots span:nth-child(2) {
    animation-delay: 0.2s;
  }
  
  .animated-dots span:nth-child(3) {
    animation-delay: 0.4s;
  }
  
  @keyframes dot-jump {
    0%, 80%, 100% {
      transform: translateY(0);
      opacity: 0.5;
    }
    40% {
      transform: translateY(-8px); /* Salto verso l'alto */
      opacity: 1;
    }
  }
  .stat-card {
    flex: 0 0 45%;
    height: calc(100vh - 360px);
    border-radius: 16px;
    padding: 2.5rem;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    font-family: 'Montserrat', sans-serif;
  }
  
  .stat-card-content {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .stat-title {
    color: white;
    font-size: 1.8rem;
    font-weight: 600;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    font-family: 'Montserrat', sans-serif;
  }
</style>